import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getQueries, completeQuery } from "../api/queryApi";
import { confirmDialog } from "../utils/alert";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";
import { formatDateTime } from "../utils/dateFormat";

function statusLabel(status) {
  if (status === 1) return "Responded";
  if (status === 0) return "Pending";
  return String(status);
}

export default function QueriesList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const res = await getQueries({ page, per_page: perPage });
      setItems(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page, perPage]);

  const handleComplete = async (id, currentStatus) => {
    if (currentStatus === 1) return;
    const confirmed = await confirmDialog({ text: "Mark this query as Responded?" });
    if (!confirmed) return;
    await completeQuery(id);
    load();
  };

  return (
    <AdminLayout title="Queries">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">Query List</h5>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Title</th>
                  <th>User</th>
                  <th>Status</th>
                  <th>Create Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="6" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && items.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No queries found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  items.map((row, index) => (
                    <tr key={row.id}>
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td>{row.subject}</td>
                      <td>
                        {row.user_first_name || row.user_last_name
                          ? `${row.user_first_name || ""} ${row.user_last_name || ""}`.trim()
                          : "-"}
                      </td>
                      <td>{statusLabel(row.status)}</td>
                      <td>{formatDateTime(row.created_at)}</td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => navigate(`/queries/detail/${row.id}`)}
                          >
                            View
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-success"
                            disabled={row.status === 1}
                            onClick={() => handleComplete(row.id, row.status)}
                          >
                            Complete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
